import { ReportRegistryService } from './../services/report/report-registry.service';
import { UserModel } from './../store/storeModels/user.model';
import { Component, OnInit } from '@angular/core';
import { EmailService } from '../services/integrations/email/email.service';
import { Store } from '@ngrx/store';
import { AppState } from '../store/app.state';
import { Observable } from 'rxjs';
import { PerformanceReportService } from '../services/report/performance-report.service';
import { GeneralService } from '../services/general.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  user_email: string;
  user_id: any;
  user: UserModel;
  selected_charts = [];
  registry_reports_are_loaded: boolean = false;
  reports_data_loaded: boolean = false;

  allReports = [
    { topclients: "Top clients" },
    { clientengagement: "Client Engagement" },
    { neglectedaccounts: "Neglected Accounts" },
    { totalinvoicesandoverdues: "Total Invoices and Overdues" },
    { timetowindeal: "Time to Win Deal" },
    { deallostbyreason: "Deal Lost By Reason" },
    { dealsourceperformance: "Deal Source Performance" },
    { percentageofdealwonbystage: "Percentage Of Deal Won by Stage" },
    { dealforecastvswon: "Deal Forecast Vs Won" },
    { newdeals: "New Deals" },
    { newinvoices: "New Invoices" },
    { newleads: "New Leads" },
    { newcontacts: "New Contacts" },
    { newcompanies: "New Companies" },
    { dealswonlost: "Deals Won / Lost" },
    { dealbyageamount: "Deal by Age/Amount" },
    { dealunchanged: "Deal Unchanged" },
    { dealstageconversion: "Deal Stage Conversion" },
    { averagedealstageduration: "Average Deal Stage Duration" },
    { dealstageduration: "Deal Stage Duration" },
    { totalsubscriptions: "Total Subscriptions" },
    { marginreport: "Margin Report" },
    { task: "Task" },
    { dealpercentagewonlost: "Deal Percentage Won / Lost" },
    { bestsellingproducts: "Best Selling Products" },
  ];

  unselectedReports = [];
  selectedReports: Observable<any>;

  dropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    enableCheckAll: false,
    itemsShowLimit: 5,
    limitSelection: 5,
    allowSearchFilter: true,
  };
  userId = this.gs.user.id;

  constructor(public report_registry: ReportRegistryService,
    private emailService: EmailService,
    private selectedUsersServ: PerformanceReportService,
    private gs: GeneralService,
    private store: Store<AppState>,
  ) {
    this.store.select('userInfo').subscribe(info => {
      this.user_email = info.user.email;
      this.user_id = info.user.id;
    });
  }

  ngOnInit() {
    this.selectedUsersServ.selected_users.next({ ids: [this.userId], type: 'salesperson' });
    this.fetchReports();
    this.emailService.email_context.next({
      name: 'dashboard',
      data: {
        email: this.user_email || "",
        id: this.user_id,
      },
    });
    this.report_registry.is_loaded.subscribe(is_loaded => {
      this.registry_reports_are_loaded = is_loaded;
    });
    console.log(this.emailService.context_primary_email_address);
  }

  fetchReports() {
    this.report_registry.fetchUserReportSelection().subscribe((response: any) => {
      const { payload, success, } = response;
      this.selected_charts = [];
      this.unselectedReports = [];
      if (success) {
        this.report_registry.convertObjectToMap(payload[0].selectedCharts).forEach(res => {

          // Select the Value from Reports that matches the subscription response.
          for (let i = 0; i < this.allReports.length; i++) {
            let key = Object.keys(this.allReports[i])[0];
            let value = Object.values(this.allReports[i])[0];
            if (key === res) {
              this.selected_charts.push(value)
              continue;
            }
          }
        });
        this.allReports.forEach(element => {
          let value = Object.values(element)[0];
          // this.selected_charts.indexOf(value) === -1 ?
          this.unselectedReports.push(value)
          // : null;
        });
        this.reports_data_loaded = true;
      }
    });
  }


  launchModal() {
    document.getElementById("ReportModal").click();
  }

  closeModal() {
    // this.loadingReq = false;
    document.getElementById("closeAddReportModal").click();
  }

  addReport() {
    this.reports_data_loaded = false;
    this.report_registry.clearReports();
    if (this.selected_charts.length > 0) {
      this.selected_charts.forEach(report => {
        var r = report.replace(/\s/g, '').toLowerCase();
        var report = r.replace('/', '').toLowerCase();
        this.report_registry.addReport(report);
      });
      this.report_registry.is_loaded.subscribe(res => {
        res ? this.fetchReports() : null;
        this.closeModal();
      });
    } else {
      this.report_registry.addReport('');
      this.report_registry.is_loaded.subscribe(res => {
        res ? this.fetchReports() : null;
        this.closeModal();
      });
    }
  }

}
